import React from 'react';
import {
  Container,
  Box,
  Typography,
  Breadcrumbs,
  Link,
} from '@mui/material';
import {
  Home as HomeIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';
import ExpenseList from '../../components/Expenses/ExpenseList';

const ExpenseManagement: React.FC = () => {
  return (
    <ExpenseList />
    
    // <Container maxWidth="xl" sx={{ py: 4 }}>
    //   {/* Breadcrumbs and Header */}
    //   <Box mb={4}>
    //     <Typography variant="h4" component="h1" sx={{ mt: 2, mb: 1 }}>
    //       Expense Management
    //     </Typography>
    //     <Typography variant="body1" color="text.secondary">
    //       Record and track vendor payments and miscellaneous expenses
    //     </Typography>
    //   </Box>

    //   {/* Main Content */}
      
    // </Container>
  );
};

export default ExpenseManagement;